export enum Gender {
    MONK = "MONK",
    NUN = "NUN",
    MALE = "MALE",
    FEMALE = "FEMALE",
    UNKNOWN = "NULL"
}

export const GenderLabel = {
    [Gender.MONK]: "ရဟန်း",
    [Gender.NUN]: "သီလရှင်",
    [Gender.MALE]: "ကျား",
    [Gender.FEMALE]: "မ",
    [Gender.UNKNOWN]: "Unknown"
}